import { Undo2, type LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Separator, Button } from '@shared/ui';

type ErrorPageTemplateProps = {
  Icon: LucideIcon;
  errorCode: number;
  errorMessage: string;
  returnRoutePath?: string | number;
  buttonText?: string;
};

export const ErrorPageTemplate = ({
  Icon,
  errorCode,
  errorMessage,
  returnRoutePath = '/',
  buttonText,
}: ErrorPageTemplateProps) => {
  return (
    <div className="flex h-screen">
      <div className="m-auto ">
        <div className="flex items-center justify-center gap-2 ">
          <div>
            <Icon />
          </div>
          <h2>
            <strong>{errorCode}</strong>{' '}
          </h2>
          <Separator orientation="vertical" className="h-[40px]" />
          <span>{errorMessage}.</span>
        </div>
        <div className="flex justify-center space-y-2 pt-5">
          <Link to={returnRoutePath as any}>
            <Button className="w-full gap-2" variant={'outline'}>
              {buttonText ?? 'Click Here To Return Back To Home'}
              <Undo2 />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
